import Services from 'services';

class RealisasiWorkOrderApi {
  page(params) {
    return Services.get('/realisasi_work_order/page', { params });
  }

  single(params) {
    return Services.get('/realisasi_work_order/single', { params });
  }

  preform(params) {
    return Services.get('/realisasi_work_order/work_order', { params });
  }

  getSingleWorkOrder(params) {
    return Services.get('/realisasi_work_order/single_work_order', { params });
  }

  getNomor(params) {
    return Services.get('/realisasi_work_order/no_baru', { params });
  }

  getDropdown(params) {
    return Services.get('/dropdown/item_w_hps', { params });
  }

  getDropdownKaryawan() {
    return Services.get('/dropdown/karyawan');
  }

  getDropdownAset() {
    return Services.get('/analisa_item_checklist/item_aset');
  }

  getDropdownVendor() {
    return Services.get('/dropdown/vendor');
  }

  save(data) {
    return Services.post('/realisasi_work_order', data);
  }
}

export default new RealisasiWorkOrderApi();
